
import { Component, Vue, Watch } from 'vue-property-decorator'
import axios from 'axios'
import { NotificationVO } from '../notification/vo/notification.vo';
import { MstCommonCodeVO } from "@/views/biz/order/vo/order.vo";
import CommonUtils from '@/common-utils';
import Constants from '@/constants';
import CommonModalDialog from "@/components/CommonModalDialog.vue";

@Component({
  components: { CommonModalDialog }
})
export default class Notification extends Vue {

    commonCodes: Array<MstCommonCodeVO> = [] as Array<MstCommonCodeVO>; // 공통코드 (알림구분)
    notifications = [] as Array<NotificationVO>; // 알림 리스트 조회
    deleteOneNotification: NotificationVO = {} as NotificationVO; // 알림 개별삭제
    notificationType: NotificationVO = {parentNotificationType : ""} as NotificationVO; // 알림 카테고리 저장
    deleteNotificationPopup =false; //삭제여부 팝업
    deleteState = ''; //전체(all), 일부(part), 개인(one) 삭제 상태체크 및 팝업 문구 변경

    get getNotifications() {
      return this.notifications;
    }


    //알림검색
    @Watch('notificationType.parentNotificationType')
    searchNotification() {
      axios.get('/notification/notifications', { params: this.notificationType } )
      .then(r=>{
          this.notifications = r.data;
          // 마지막 읽은 알림 처리
          if(this.notifications.length) {
            CommonUtils.putLocalStorageObject(Constants.NOTIFICATION_SEQ2, Object(this.notifications[0].seq));
            this.$store.commit("hasNewNotification", false);
          }
      });
    }

    //읽은알림처리
    readNotification(item: NotificationVO) {
      if(this.deleteNotificationPopup){
          return;
      }
      if(item.link == null && item.readYn == 'Y'){
        return;
      }
      if(item.readYn == 'N') {
        axios.put(`/notification/${item.seq}`,item).then((r)=>{
          item.link == null? this.searchNotification() : this.$router.push(item.link);
        });        
      }else{
        this.$router.push(item.link);
      }
    }      
    
    //알림삭제(전체, 읽은알림, 개별)
    deleteNotification() {
      switch(this.deleteState){
        case 'all':
          axios.delete(`/notification/notifications`,{ params: this.notificationType }).then(r=>{
            this.searchNotification();
          });      
          break;
        case 'part':
          axios.delete(`/notification/read`,{ params: this.notificationType }).then(r=>{
            this.searchNotification();
          });      
          break;
        case 'one':
          axios.delete(`/notification/${this.deleteOneNotification.seq}`).then(r=>{
            this.searchNotification();
          });      
          break;
      }
    }

    created() {
      //알림검색
      this.searchNotification();
      //공통코드(알림구분 '032')
      axios.get(`/common/code/codes/032`).then((r) => {
        this.commonCodes = r.data;
      });      
    }
}
